export default __webpack_public_path__ + "static/media/2.cf0114b1.jpg";